// Footer.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Footer.css'

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-copyright">
            © {new Date().getFullYear()} DynaStoxx. Alle Rechte vorbehalten.
          </div>
          <div className="footer-links">
            <Link to="/impressum" className="footer-link">
              Impressum
            </Link>
            <Link to="/datenschutz" className="footer-link">
              Datenschutz
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;